import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import API from 'api/API';
import { BulkUploadType } from 'api/Responses/BulkUploadResponses';

interface UseDataUploadList {
  uploadList: BulkUploadType[];
  getUploadList: (filterSearch?: string) => Promise<void>;
  loading: boolean;
  refresh: boolean;
  setRefresh: Dispatch<SetStateAction<boolean>>;
}

const useDataUploadList = (): UseDataUploadList => {
  const [uploadList, setUploadList] = useState<BulkUploadType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(true);

  const getUploadList = useCallback(async (filterSearch?: string) => {
    try {
      const response = await API.bulkUpload.getUploadList();
      const list = response.bulk_uploads;

      const filteredResponse = filterSearch
        ? list.filter(item => item.filename.toLowerCase().includes(filterSearch.toLowerCase()))
        : list;

      setUploadList(filteredResponse);
      setLoading(false);
    } catch (error) {
      API.errorHandler(error);
    }
  }, []);

  // on load
  useEffect(() => {
    (async () => {
      try {
        await getUploadList();
      } catch (e) {
        API.errorHandler(e);
      }
    })();
  }, [getUploadList]);

  // Fetch all drafts from the DB
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (refresh) {
          const response = await API.bulkUpload.getUploadList();
          const list = response.bulk_uploads;

          setUploadList(list);
          setLoading(false);
          setRefresh(false);
        }
      } catch (error) {
        API.errorHandler(error);
      }
      setLoading(false);
    })();
  }, [refresh]);

  return { refresh, setRefresh, uploadList, getUploadList, loading };
};

export default useDataUploadList;
